// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"134411a2","218":"d6a3eecc","488":"daacfcfc","586":"dac4a8df","593":"28144d62","662":"d24ea8f4","892":"5cde83ed","906":"3ada9420","912":"afc3df82","970":"516c7982","979":"775cf249","992":"921a62e5"}[chunkId] + ".chunk.js";
};